import gql from 'graphql-tag'
import { productRequired, productMain, options, properties, lists, intervals } from '../fragments'

const mutation = gql`
mutation updateManyProducts($idArr: [ID]!, $fields: ProductFields!) {
	cashAssist {
		updateManyProducts(idArr: $idArr, fields: $fields) {
			...productRequired
			...productmain
			...options

			img {
				uid
				key
			}
			imgKiosk {
				uid
				key
			}
			specialPrices {
				id
				type
				typeName
				fromDate
				toDate
				name
			}
			...properties
			cashRegisterId
			category {
				id
				name
			}
			...lists
			...intervals
			isWeighted
			isTareInLabelMode
			tare
			EANCode
			EANstatistics
			cardChargeAmount
			cardSurchargePercent
			cardSurchargeFrom
			discount
			points {
				type
				quantity
				points
			}
			pointsCost
			pointsPriceLevel
			isInventory
			inventoryUnit
			minOrder
			numberPerUnit
			nameInOrder
			canCopy
			orderUnit
			visibleStatus
			bakeryReturn
			bakeryReturnEndOfDay
			bakeryStock
			FA_ProductId
		}
	}
}
${productRequired}
${productMain}
${options}
${properties}
${lists}
${intervals}`

export default mutation
